<div class="container">
  <button class="btn btn-primary btn-add-new" [routerLink]="['../admin-new']">
    {{ 'label.AddNew' | translate }}
  </button>

  <p-table [value]="adminUsers" showGridlines>
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'label.FullName' | translate }}</th>
        <th>{{ 'label.Email' | translate }}</th>
        <th style="width: 10%">{{ 'label.Position' | translate }}</th>
        <th style="width: 10%">{{ 'label.DateAdded' | translate }}</th>
        <th style="width: 28%">{{ 'label.Permissions' | translate }}</th>
        <th style="width: 15%">{{ 'label.Actions' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-adminUsers>
      <tr>
        <td>{{ adminUsers.fullName }}</td>
        <td>{{ adminUsers.email }}</td>
        <td>{{ adminUsers.position }}</td>
        <td>{{ adminUsers.dateAdded | date : 'dd/MM/yyyy' }}</td>
        <td>
          <div *ngFor="let permission of adminUsers.permissions; let pL = last">
            <span *ngFor="let feature of permission.features; let fL = last">
              {{ feature.name }}
              <span *ngIf="!pL || !fL">,</span>
            </span>
          </div>
        </td>
        <td>
          <button
            class="btn btn-secondary btn-custom"
            [routerLink]="['../admin-edit', adminUsers.adminId]"
          >
            {{ 'label.Edit' | translate }}
          </button>
          <button class="btn btn-danger btn-custom">
            {{ 'label.Delete' | translate }}
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
